import { createRouter, createWebHistory } from 'vue-router';
import axios from 'axios';
import LandingPage from '../views/Home/LandingPage.vue';
import GetStarted from '../views/Authentication/GetStarted.vue';
import Cases from '../views/CrimeTime/Cases.vue';
import { resolveLandingRoute, getStoredModuleAccess, moduleForPath, isModuleEnabled } from '../moduleAccess.js';
import maintenanceHelper from '../maintenance.js';
// import { before } from 'lodash';
// import { handleError } from '../helpers';
  const allowedGetStartedTypes = ['individual', 'enterprise'];

// Bounces navigation to a module the enterprise has disabled (enterprise module
// gating); the matching API endpoints also 403 server-side via tools.requireModule.
function moduleGuard(to) {
  const moduleAccess = getStoredModuleAccess();
  const moduleName = moduleForPath(to.path);
  if (moduleName && !isModuleEnabled(moduleAccess?.availableModules, moduleName)) {
    return resolveLandingRoute(moduleAccess);
  }
  return true;
}

//Gets called before every route change to check user credentials
async function authCheck(_to, _from) {
  const token = localStorage.getItem('user_token');
  // IF THERE IS NO TOKEN, REDIRECT TO LOGIN
  if (!token || token?.length == 0) {
    router.push('/login');
  } else {
    const bodyObj = { user_token: token, source: 'routerAuthCheck' };
    const headerObj = {
      headers: { Authorization: `Bearer ` + token }
    };
    try {
      await axios.post(process.env.VUE_APP_ENDPOINT + '/api/auth/checkcredentials', bodyObj, headerObj);
      // const data = response.data;
      // Handling successful data retrieval
      return true;
    } catch (error) {
      // handleError(error)
      const responseStatus = error?.status;
      const responseData = error.response?.data;

     
      if (responseStatus === 402) {
        const subscriptionStatus = responseData?.subscription_status;

        if (subscriptionStatus === 'Student_Expired') {
          router.push({ name: 'ErrorPage', query: { code: 402, reason: 'student' } });
        } else if (subscriptionStatus === 'County_Expired') {
          router.push({ path: '/CountyExpired' });
        } else if (subscriptionStatus === 'No_Stripe_ID' || subscriptionStatus === 'No_Subscription' || subscriptionStatus == 'Removed_From_County') {
          router.push({ path: '/CreateSubscription' });
        } else if (subscriptionStatus === 'Expired') {
          router.push({ path: '/reactivateSubscription' });
        } else if (subscriptionStatus === 'Pending Invitation Status') {
          router.push({ path: '/invitation/pending' });
        } else {
          router.push({ name: 'ErrorPage', query: { code: 402 } });
        }
      } else if (responseStatus === 410) {
        router.push('/error?code=410');
      } else if(responseStatus === 404 || responseStatus == 500){
        router.push('/error?code=' + responseStatus);
      } else if(responseStatus === 405){
        router.push('/login');
      } else{
        router.push('/login');
      }
    }
  }
}

//Handle user going to create subscription or reactivate subscription with active subscription
async function validSubscriptionCheck(_to, _from) {
  const token = localStorage.getItem('user_token');
  const JWTUser = JSON.parse(localStorage.getItem('user_attr'));

  // IF THERE IS NO TOKEN, REDIRECT TO LOGIN
  if (!token || token.length === 0) {
    router.push('/login');
  } else {
    const bodyObj = { user_token: token };
    const headerObj = {
      headers: { Authorization: `Bearer ` + token }
    };
    try {
      if (JWTUser?.Subscriber?.SubscriptionType !== 3) {
        await axios.post(process.env.VUE_APP_ENDPOINT + '/api/auth/subscriptionCheck', bodyObj, headerObj);
        // const data = response.data;
      } else {
        router.push('/');
      }
      // User has a valid subscription
      // if (JWTUser.Subscriber.SubscriptionType === 3) {
      //   router.go(-1);
      // }
      if (response?.status === 200) {
        //if user is trying to go back once subscribed, just send them in the app
       if (
         (this.$route.name || '').toUpperCase() === 'GETSTARTED/INDIVIDUAL' ||
         (this.$route.name || '').toUpperCase() === 'GETSTARTED/ENTERPRISE'
       ) {
         router.push('/');
       } else {
         router.go(-1);
       }

        return false;
      }

      return true;
    } catch (error) {
      // console.error('Error:: ', error);
      const responseStatus = error?.status;

      const responseData = error.response?.data;
      const subscriptionStatus = responseData?.subscription_status;

      if (responseStatus === 401) {
        // Unauthorized - Clear user data and redirect to login
        localStorage.setItem('user_token', '');
        localStorage.setItem('user_attr', '');
        localStorage.setItem('user_key', '');
        localStorage.setItem('subscription_status', '');
        router.push('/login');
      } else if (responseStatus === 402) {
        // Payment Required - Check subscription status and redirect accordingly
        if (subscriptionStatus === 'Expired') {
          return true;
          //Valid so do nothing so they pass through
        } else if (subscriptionStatus === 'Create_Subscription') {
          return true;
          //Valid so do nothing so they pass through
        } else {
          router.push({ name: 'ErrorPage', query: { code: 402 } });
        }
      } else if (responseStatus === 404) {
        // Status doesn't allow you to be here - push to the previous page
        router.go(-1);
      } else if (responseStatus === 500) {
        // Internal Server Error - Redirect to ErrorPage
        router.push({ name: 'ErrorPage', query: { code: 500 } });
      } else if (responseStatus === 429) {
        // Too Many Requests - Redirect to home page
        router.push({ path: '/' });
      } else {
        router.push({ name: 'ErrorPage', query: { code: 500 } });
        // console.error(error);
      }
    }
  }
}

const routes = [
  {
    path: '/',
    redirect: () => resolveLandingRoute(getStoredModuleAccess())
  },
  {
    path: '/maintenance',
    name: 'Maintenance',
    component: () => import('../views/Authentication/Maintenance.vue')
  },
  {
    path: '/error',
    name: 'ErrorPage',
    props: (route) => ({ errorCode: Number(route.query.code) }),
    component: () => import('../views/Authentication/ErrorPage.vue')
  },
  {
    path: '/login',
    name: 'Login',
    // beforeEnter: [loginCheck],
    component: () => import('../views/Authentication/Login.vue')
  },

  {
    path: '/Cases',
    name: 'Cases',
    beforeEnter: [authCheck, moduleGuard],
    component: Cases
  },
  {
    path: '/Cases/:caseId',
    name: 'CaseDetails',
    beforeEnter: [authCheck, moduleGuard],
    component: () => import('../views/CrimeTime/CaseDetails.vue')
  },
  // {
  //   path: '/GetStarted',
  //   name: 'GetStarted',
  //   component: GetStarted
  // },

  //   {
  //   path: '/GetStarted',
  //   redirect: { name: 'GetStarted', params: { type: 'individual' } }
  // },
  {
    path: '/getstarted',
    redirect: { name: 'GetStarted', params: { type: 'individual' } }
  },

    {
    path: '/getstarted/:type',
    name: 'GetStarted',
    component: GetStarted,
    beforeEnter: (to, from, next) => {
      const type = to.params.type;
      if (allowedGetStartedTypes.includes(type)) {
        next(); // Allow navigation
      } else {
        // Redirect to a default route or show an error
        next(false);
      }
    },
  },
  
  {
    path: '/landingPage',
    name: 'landingPage',
    component: LandingPage
  },
  // {
  //   path: '/Order',
  //   name: 'Order',
  //   component: () => import('../views/Order.vue')
  // },
  {
    path: '/signup/:SubscriberId',
    name: 'signUp',
    async beforeEnter(to, from, next) {
      const subscriberAdminGuid = to.params.SubscriberId;
      await axios.get(process.env.VUE_APP_ENDPOINT + `/api/getSubscriberInfoFromUserGuid/${to?.params?.SubscriberId}`)
      .then((data) => {

        const subscriberDataValues = {
          SubscriberId: data?.data?.SubscriberId,
          EnforceMicrosoftSignOn: data?.data?.EnforceMicrosoftSignOn,
          WhichCounty: data?.data?.WhichCounty,
          WhichAgency: data?.data?.WhichAgency,
          ApproveCountyUsers: data?.data?.ApproveCountyUsers,
          NotifyAdminOfNewUserSignUp: data?.data?.NotifyAdminOfNewUserSignUp,
          GUID: subscriberAdminGuid
        };
        localStorage.setItem('subscriberDataValues', JSON.stringify(subscriberDataValues));

        
        next({ path: '/signupWithCode' });
    }).catch(_e => {
      this.error = "Invalid Url";

    }).catch(_e => {
      
      next({ path: '/' });
    });
    }
  },
  {
    path: '/signupWithCode',
    name: 'signupWithCode',
    component: () => import('../views/Authentication/OrderWithCode.vue')
  },
  {
    path: '/auth/microsoft-callback',
    name: 'MicrosoftCallback',
    component: () => import('../views/Authentication/MicrosoftCallback.vue'),
  },
  // {
  //   path: '/signup/:SubscriberId',
  //   name: 'signUp',
  //   component: () => import('../views/Authentication/OrderWithCode.vue')
  // },
  {
    path: '/subscriptionSuccess',
    name: 'SubscriptionSuccess',
    component: () => import('../views/Authentication/StripeSuccess.vue')
  },
  {
    path: '/subscriptionConfirm',
    name: 'SubscriptionConfirm',

    async beforeEnter(to, from, next) {
      const params = to.query;
      const token = localStorage.getItem('user_token');
      // const userKey = localStorage.getItem('user_key');
      // const JWTUser = JSON.parse(localStorage.getItem('user_attr'));

      if (token && params.setup_intent) {
        try {
          // Confirm subscription email
          const response = await axios.post(
            process.env.VUE_APP_ENDPOINT + '/api/stripesubscription/confirmSubscription',
            {
              stripeParams: params,
              user_token: token
            },
            {
              headers: { Authorization: `Bearer ` + token }
            }
          );

          if (response.status === 200 || response.status === 201) {
            // Send the confirmation email
            await axios.post(
              `${process.env.VUE_APP_ENDPOINT}/api/registration/sendNewSubscriptionEmail`,
              {},
              {
                headers: {
                  Authorization: `Bearer ` + token
                }
              }
            );

            // Navigate to the success page
            next({ path: '/subscriptionSuccess' });
          } else {
            // Handle non-successful response
            next(); // Allow the navigation to continue if there's an issue
          }
        } catch (error) {
          console.error('Error during subscription confirmation:', error);
          next(); // Allow the navigation to continue if there's an issue
        }
      } else {
        next(); // Allow the navigation to continue if the conditions are not met
      }
    }
  },

  {
    path: '/myaccount',
    name: 'Account',
    // beforeEnter: [authCheck],
    component: () => import('../views/Profile/Account.vue')
  },
  {
    path: '/singleSearch',
    name: 'NewSingleSearch',
    beforeEnter: [authCheck, moduleGuard],
    component: () => import('../views/CrimeFinder/NewSingleSearch.vue')
  },
  {
    path: '/creditCalculator',
    name: 'CreditCalculator',
    beforeEnter: [authCheck, moduleGuard],
    component: () => import('../views/CreditCalculator/CreditCalculator.vue')
  },
  {
    path: '/juryInstructions',
    name: 'JuryInstructions',
    beforeEnter: [authCheck],
    component: () => import('../views/JuryInstructions/JuryInstructions.vue')
  },
  {
    path: '/CreateSubscription',
    name: 'CreateSubscription',
    beforeEnter: [validSubscriptionCheck],
    component: () => import('../views/Authentication/CreateSubscription')
  },
  {
    path: '/ReactivateSubscription',
    name: 'ReactivateSubscription',
    beforeEnter: [validSubscriptionCheck],
    component: () => import('../views/Authentication/ReactivateSubscription')
  },
  {
    path: '/invitation/pending',
    name: 'CountyInvitationPendingPage',
    component: () => import('../views/Authentication/CountyInvitationPendingPage.vue')
  },
  {
    path: '/CountyExpired',
    name: 'CountyExpired',
    component: () => import('../views/Authentication/CountyExpired')
  },
  {
    path: '/ReleaseDate',
    name: 'ReleaseDate',
    beforeEnter: [authCheck],
    component: () => import('../views/CreditCalculator/ReleaseDateCalculator.vue')
  },
  {
    path: '/products',
    name: 'Products',
    component: () => import('../views/Shop/Products.vue')
  },
  {
    path: '/MicrosoftLoginRedirect',
    name: 'MicrosoftLoginRedirect',
    component: () => import('../views/Authentication/MicrosoftLoginRedirect.vue')
  },
  // {
  //   path: '/Help',
  //   name: 'Help',
  //   component: () => import('../views/Help/Help.vue')
  // },
  {
    path: '/ShopConfirm',
    name: 'ShopConfirm',
    component: () => import('../views/Shop/ShopConfirm.vue')
  },
  // {
  //   path: '/Negotiator',
  //   name: 'Negotiator',
  //   component: () => import('../views/Negotiator/Negotiator.vue')
  // }
];

const router = createRouter({
  history: createWebHistory(),
  routes
});

// Maintenance mode: a global guard (runs before per-route beforeEnter) that checks the statically
// served, live-editable /maintenance.json and bounces everyone to the maintenance screen when it's
// enabled. Works even while the DB/API is down (the file is served by the static host). Staff can
// bypass by visiting ?mbypass=<token> once (stored in sessionStorage) when a bypassToken is set.
let maintenanceCache = { data: null, at: 0 };
async function loadMaintenanceConfig() {
  const now = Date.now();
  if (maintenanceCache.data && now - maintenanceCache.at < 15000) return maintenanceCache.data;
  try {
    const res = await fetch('/maintenance.json?t=' + now, { cache: 'no-store' });
    const data = res.ok ? await res.json() : { enabled: false };
    maintenanceCache = { data, at: now };
    return data;
  } catch (e) {
    return { enabled: false }; // never lock users out on a fetch error
  }
}

router.beforeEach(async (to, from, next) => {
  try {
    if (to.query && to.query.mbypass) sessionStorage.setItem('mbypass', String(to.query.mbypass));
  } catch (e) { /* ignore storage errors */ }
  let bypassToken = null;
  try { bypassToken = sessionStorage.getItem('mbypass'); } catch (e) { /* ignore */ }

  const config = await loadMaintenanceConfig();
  const target = maintenanceHelper.maintenanceTarget({ config, routeName: to.name, bypassToken });
  if (target && target !== to.path) return next(target);
  return next();
});

export default router;